import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeftStartOnRectangleIcon, PlusCircleIcon, HomeIcon, WrenchScrewdriverIcon, ClipboardDocumentListIcon, QueueListIcon, DocumentTextIcon, Cog6ToothIcon } from "@heroicons/react/24/outline";
import LoginButton from "./LoginButton";
import RequireRole from "./RequireRol";

const Header = ({ usuario, onLogout }) => {
    return (
        <header className="bg-white shadow px-6 py-4 flex justify-between items-center rounded">
            <Link to="/" className="flex items-center">
                <img
                    src="/banner.png"
                    alt="Reformista logo"
                    className="h-12 sm:h-16 md:h-20 object-contain"
                />
            </Link>

            {usuario ? (
                <div className="flex items-center gap-4">
                    <RequireRole allowedRoles={["admin", "inversor"]} showError={false}>
                        <Link
                            to="/listado"
                            className="flex items-center gap-1 text-sm text-blue-600 hover:text-blue-800"
                            title="Listado"
                        >
                            <QueueListIcon className="h-5 w-5" />
                            <span className="hidden sm:inline">Listado</span>
                        </Link>
                    </RequireRole>
                    <RequireRole allowedRoles={["admin", "gestor_inmobiliario"]} showError={false}>
                        <Link
                            to="/constructores"
                            className="flex items-center gap-1 text-sm text-blue-600 hover:text-blue-800"
                            title="Mis Constructores"
                        >
                            <WrenchScrewdriverIcon className="h-5 w-5" />
                            <span className="hidden sm:inline">Mis constructores</span>
                        </Link>
                    </RequireRole>
                    <Link
                        to="/actuaciones"
                        className="flex items-center gap-1 text-sm text-blue-600 hover:text-blue-800"
                        title="Actuaciones"
                    >
                        <ClipboardDocumentListIcon className="h-5 w-5" />
                        <span className="hidden sm:inline">Mis modelos de reforma</span>
                    </Link>
                    <RequireRole allowedRoles={["propietario", "gestor_inmobiliario"]} showError={false}>
                        <Link
                            to="/mis-propiedades"
                            className="flex items-center gap-1 text-sm text-blue-600 hover:text-blue-800"
                            title="Mis propiedades"
                        >
                            <HomeIcon className="h-5 w-5" />
                            <span className="hidden sm:inline">Mis propiedades</span>
                        </Link>
                    </RequireRole>
                    <Link
                        to="/mis-informes"
                        className="flex items-center gap-1 text-sm text-blue-600 hover:text-blue-800"
                        title="Mis Informes"
                    >
                        <DocumentTextIcon className="h-5 w-5" />
                        <span className="hidden sm:inline">Mis informes</span>
                    </Link>
                    <Link
                        to="/analizarpropiedad/nueva"
                        className="flex items-center gap-1 text-sm text-blue-600 hover:text-blue-800"
                        title="Añadir propiedad"
                    >
                        <PlusCircleIcon className="h-5 w-5" />
                        <span className="hidden sm:inline">Añadir propiedad</span>
                    </Link>
                    <Link
                        to="/ajustes"
                        className="flex items-center gap-1 text-sm text-blue-600 hover:text-blue-800"
                        title="Ajustes"
                    >
                        <Cog6ToothIcon className="h-5 w-5" />
                        <span className="hidden sm:inline">Ajustes</span>
                    </Link>
                    <span className="text-sm text-brand-gray hidden sm:inline">{usuario.email}</span>
                    <img
                        src={usuario.avatar || "/default-avatar.png"}
                        alt="Avatar"
                        className="w-8 h-8 rounded-full border border-gray-300"
                    />
                    <button
                        onClick={onLogout}
                        className="flex items-center gap-1 text-sm text-gray-600 hover:text-red-600"
                        title="Cerrar sesión"
                    >
                        <ArrowLeftStartOnRectangleIcon className="h-5 w-5" />
                        <span className="hidden sm:inline">Logout</span>
                    </button>
                </div>
            ) : (
                <LoginButton />
            )}
        </header>
    );
};

export default Header;
